import React from 'react';
import favorite from 'src/assets/images/heart-un-favorite.png';
import unFavorite from 'src/assets/images/heart-favorite.png';
import httpRequest from 'src/helpers/httpRequest';
import { useDispatch, useSelector } from 'react-redux';
import { AppDispatch, RootState } from 'src/Store/store';
import { tooglePleaseLogin } from 'src/Store/reducer';

interface IProps {
    onSuccess: (obj: { productId: string; isLiked: boolean }) => void;
    productId: string;
    isFav: boolean;
    background?: boolean;
    category: "tests" | "package" | "pharmacy" | "homecare" | "doctor";
};

const IsFavoriteComponent: React.FC<IProps> = ({
    onSuccess = () => { },
    productId = "",
    isFav = false,
    background = true,
    category = "tests"
}) => {
    const dispatch = useDispatch<AppDispatch>();
    const { isLogged } = useSelector((store: RootState) => store.appReducer);
    const toggleFavorite = async () => {
        const method = "get"
        const path =
            category === "pharmacy" ? `/inventory-favProduct/toggle/${productId}`
                : category === "tests" ? `/product/toggle/${productId}`
                    : category === "package" ? `/diagnostic-package/toggle/${productId}`
                        : category === "homecare" ? `/home-care-services/toggle/${productId}`
                            : category === "doctor" ? `/provider/toggle/${productId}`
                                : "";
        const { res, err } = await httpRequest<{ message: string; isLiked: boolean; }>({ method, path });
        if (res) {
            const { message = "", isLiked = false } = res;
            onSuccess({ productId, isLiked });
        } else {
            console.log("ERROR", err);
        }
    };

    return (
        <button
            onClick={() =>
                isLogged ?
                    toggleFavorite()
                    :
                    dispatch(tooglePleaseLogin(true))
            }
            className={`favorite-un-favorite ${background ? 'favorite-un-favorite-bg-add' : ''}`}>
            <img
                src={isFav ? unFavorite : favorite}
                alt="favorite-icon"
                className={`${isFav
                    ? 'favorite-un-favorite-scale-down'
                    : 'favorite-un-favorite-scale-up'
                    }`}
            />
        </button >
    );
};

export default IsFavoriteComponent;